import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  DatePicker,
  Input,
  Modal as ModalAntd,
  Row,
  Space,
  Table,
  Tag,
  Tooltip,
} from 'antd';
import {
  CommentOutlined,
  EyeOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
  ReloadOutlined,
  ExclamationCircleOutlined,
  EditOutlined,
  SearchOutlined,
  FileExcelFilled,
  FilePdfFilled,
} from '@ant-design/icons';
import Modal from '../../General/Modal';
import { useHistory } from 'react-router';
import {
    METHOD_DELETE,
  METHOD_GET, ROL_ADMIN, ROL_LAYOUT, ROL_OPERACIONES, ROL_PRICING, ROL_VENTAS,
} from '../../../utils/constants';
import { getAccessTokenApi } from '../../../api/auth';
import { fetchApi } from '../../../helpers/fetch';
import moment from 'moment';
import Highlighter from 'react-highlight-words';
import { isMobile } from '../../../utils/general';
import XLSX from 'xlsx';
import jsPDF from 'jspdf';
import { getFilteredDataFromLocalStorage, saveFilteredDataToLocalStorage } from '../../../helpers/saveFilterData';
import useUser from '../../../hooks/useUser';
import AddEditAvailableUnit from './AddEditAvailableUnits/AddEditAvailableUnit';
import confirm from 'antd/lib/modal/confirm';

const AvailableUnitsTable = ({date}) => {
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [titleModal, setTitleModal] = useState(false);
  const [contextModal, setContextModal] = useState(null);
  const { person } = useUser();
  const [isLoadingTable, setIsLoadingTable] = useState(true);
  const token = getAccessTokenApi();
  const [reloadTable, setReloadTable] = useState(false);
  const [quotes, setQuotes] = useState([]);
  const [startDate, setStartDate] = useState({
    createdAt: '',
    startDate: '',
    endDate: '',
  });
  const [endDate, setEndDate] = useState({
    createdAt: '',
    startDate: '',
    endDate: '',
  });
  const x = React.createRef();
  const [searchedColumn, setSearchedColumn] = useState('');
  const [filteredInfo, setFilteredInfo] = useState({});
  const [searchText, setSearchText] = useState('');
  const classButtonDownload = isMobile()
    ? 'btn-download-mobile'
    : 'btn-download';

  useEffect(() => {
    setIsLoadingTable(true);

    const config = {
      method: METHOD_GET,
      url: `AvailableUnits`,
      data: null,
      token,
      showNotificationError: true,
    };
    fetchApi(config)
      .then((response) => {
        if (response.statusCode === 200 && response.result) {
          const allQuotes = response.result;
          allQuotes.map((quote) => (quote['key'] = quote.id));
            setQuotes(allQuotes);
        }
        setIsLoadingTable(false);
        setReloadTable(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoadingTable(false);
        setReloadTable(false);
      });
  }, [reloadTable, token,date]);
  useEffect(() => {
    const datosObtenidos = getFilteredDataFromLocalStorage('availableUnits');
    if (datosObtenidos !== null) {
      setFilteredInfo(datosObtenidos.filters);
      setStartDate(datosObtenidos.dateFilters.startDates)
      setEndDate(datosObtenidos.dateFilters.endDates)
    }
  },[])
  const getColumnSearchDateProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Col>
          <DatePicker
            ref={x}
            id={'startDate' + dataIndex}
            placeholder={'Fecha inicial'}
            style={{ marginRight: '10px' }}
            format="DD/MM/YYYY"
            allowClear={false}
            value={
              startDate[dataIndex] !== ''
                ? moment.unix(startDate[dataIndex])
                : null
            }
            onChange={(e) => {
              // setStartDate(moment(e).unix());
              startDate[dataIndex] = moment(e).startOf('day').unix();
              setSelectedKeys(
                quotes
                  .filter(
                    (op) =>
                      moment(e)
                        .hours(0)
                        .minutes(0)
                        .seconds(0)
                        .milliseconds(0)
                        .unix() <= op[dataIndex]
                  )
                  .map((op) => op.key)
              );

              // setSelectedKeys(e !== null ? [e.format('DD/MM/YYYY')] : [])
            }}
          />
          <DatePicker
            placeholder={'Fecha final'}
            format="DD/MM/YYYY"
            allowClear={false}
            value={
              endDate[dataIndex] !== '' ? moment.unix(endDate[dataIndex]) : null
            }
            onChange={(e) => {
              // setEndDate(moment(e).unix());
              endDate[dataIndex] = moment(e).endOf('day').unix();
              setSelectedKeys(
                quotes
                  .filter(
                    (op) =>
                      op[dataIndex] <=
                      moment(e)
                        .hours(23)
                        .minutes(59)
                        .seconds(59)
                        .milliseconds(0)
                        .unix()
                  )
                  .map((op) => op.key)
              );
            }}
          />
        </Col>
        <Row justify="end" gutter={16}>
          <Col>
            <Button
            disabled={endDate[dataIndex] === ''}
              type="primary"
              onClick={() => {
                handleSearchDate(selectedKeys, confirm);
                setSelectedKeys(
                  quotes
                    .filter(
                      (d) =>
                        startDate[dataIndex] <= d[dataIndex] &&
                        d[dataIndex] <= endDate[dataIndex]
                    )
                    .map((d) => d.key)
                );
              }}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Buscar
            </Button>
            <Button
              onClick={() => {
                handleReset(clearFilters, selectedKeys, confirm, dataIndex);
                handleSearchDate(selectedKeys, confirm, dataIndex);
              }}
              size="small"
              style={{ width: 90 }}
            >
              Limpiar
            </Button>
          </Col>
        </Row>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      startDate[dataIndex] <= record[dataIndex] &&
      record[dataIndex] <= endDate[dataIndex],
    filteredValue: filteredInfo[dataIndex] || null,
    onFilterDropdownVisibleChange: (visible) => {},
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? moment.unix(text).format('DD/MM/YYYY') : ''}
        />
      ) : (
        moment.unix(text).format('DD/MM/YYYY')
      ),
  });
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            // this.searchInput = node;
          }}
          placeholder={`Buscar`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => {
              handleReset(clearFilters);
              handleSearch(selectedKeys, confirm, dataIndex);
            }}
            size="small"
            style={{ width: 90 }}
          >
            Limpiar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : '',
    filteredValue: filteredInfo[dataIndex] || null,
    onFilterDropdownVisibleChange: (visible) => {},
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });
  const showModal = (type, data) => {
    if (type === 'add') {
      setModalIsVisible(true);
      setTitleModal('Agregar unidad disponible');
      setContextModal(
        <AddEditAvailableUnit
          setModalIsVisible={setModalIsVisible}
          type={type}
          setReloadTable={setReloadTable}
        ></AddEditAvailableUnit>
      );
    } else if (type === 'edit') {
      setModalIsVisible(true);
      setTitleModal( `Editar unidad disponible` );
      setContextModal(
        <AddEditAvailableUnit
          setModalIsVisible={setModalIsVisible}
          type={type}
          data={data}
          setReloadTable={setReloadTable}
        ></AddEditAvailableUnit>
      );
    } 
    else if (type === 'watch') {
        setModalIsVisible(true);
        setTitleModal( `Unidad disponible` );
        setContextModal(
          <AddEditAvailableUnit
            setModalIsVisible={setModalIsVisible}
            type={type}
            data={data}
          ></AddEditAvailableUnit>
        );
      } 
  };
  const handleDeleteAvailableUnit = (id) => {
    confirm({
      title: 'Eliminar unidad disponible',
      icon: <ExclamationCircleOutlined />,
      content:
        '¿Estás seguro que deseas eliminar la unidad disponible seleccionada?',
      okText: 'Si',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteAvailableUnit(id);
      },
      onCancel() {},
    });
  };

  const deleteAvailableUnit = async (id) => {
    const config = {
      method: METHOD_DELETE,
      url: `AvailableUnits/${id}`,
      data: null,
      token,
      showNotification: true,
    };
    const result = await fetchApi(config);

    if (result) {
      if (result.statusCode === 200) {
        setReloadTable(true);
      }
    }
  };
  const columns = [
    {
      title: 'Servicio',
      dataIndex: 'serviceDescription',
      key: 'serviceDescription',
      width: 150,
      align: 'center',
      ...getColumnSearchProps('serviceDescription'),
    },
    {
        title: 'Unidad',
        dataIndex: 'equipmentTypeDescription',
        key: 'equipmentTypeDescription',
        width: 150,
        align: 'center',
        ...getColumnSearchProps('equipmentTypeDescription'),
    },
    {
    title: 'Ubicación',
      children: [
    {
      title: 'Ciudad',
      dataIndex: 'locationCityDescription',
      key: 'locationCityDescription',
      width: 200,
      align: 'center',
      ...getColumnSearchProps('locationCityDescription'),
    },
    {
        title: 'Estado',
        dataIndex: 'locationStateDescription',
        key: 'locationStateDescription',
        width: 200,
        align: 'center',
        ...getColumnSearchProps('locationStateDescription'),
    },
  ]
  },
  {
    title: 'Fecha',
    dataIndex: 'date',
    key: 'date',
    width: 130,
    align: 'center',
    render: (date) => <>{moment.unix(date).tz('GMT').format('DD/MM/YYYY')}</>,
},
  {
    title: 'Carga',
    dataIndex: 'loadTypeDescription',
    key: 'loadTypeDescription',
    width: 130,
    align: 'center',
    ...getColumnSearchProps('loadTypeDescription'),
},
  {
    title: 'Destino',
      children: [
    {
      title: 'Ciudad',
      dataIndex: 'destinationCityDescription',
      key: 'destinationCityDescription',
      width: 200,
      align: 'center',
      ...getColumnSearchProps('destinationCityDescription'),
    },
    {
      title: 'Estado',
      dataIndex: 'destinationStateDescription',
      key: 'destinationStateDescription',
      width: 200,
      align: 'center',
      ...getColumnSearchProps('destinationStateDescription'),
    },
  ]
  },
    {
      title: 'Estatus',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      align: 'center',
      filters: [
        { text: 'Disponible', value: 0 },
        { text: 'Apartado', value: 1 },
        { text: 'Expirado', value: 2 },
      ],
      filteredValue: filteredInfo.status || null,
      onFilter: (value, record) => record.status === value,
      render: (status) => (
        <Tag
          color={
            status === 0
              ? 'green'
              : status === 2
              ? 'red'
              : 'yellow'
          }
        >
          { status === 0
              ? 'Disponible'
              : status === 2
              ? 'Expirado'
              : 'Apartado'}
        </Tag>
      ),
    },
    {
        title: 'Proveedor',
        dataIndex: 'supplierId',
        key: 'supplierId',
        width: 200,
        align: 'center',
        ...getColumnSearchProps('supplierId'),
      },
    {
      title: 'Acciones',
      key: 'comentId',
      fixed: 'right',
      width: 140,
      align: 'center',
      render: (record) => (
        <>
            {[ROL_LAYOUT, ROL_ADMIN,ROL_VENTAS,ROL_OPERACIONES,ROL_PRICING].some((r) => person.roles.includes(r)) && (
            <>
            <Tooltip title="Editar">
                  <Button
                    onClick={() => showModal('edit',record) }
                    type="primary"
                    icon={<EditOutlined />}
                    disabled={record.status !== 0}
                  ></Button>
                </Tooltip>
              <Tooltip title="Ver">
                <Button
                  style={{ marginLeft: 2 }}
                  type="primary"
                  shape="default"
                  icon={<EyeOutlined />}
                  onClick={() => showModal('watch', record)}
                />
              </Tooltip>
              <Tooltip title="Eliminar">
                  <Button
                    danger
                    style={{ marginLeft: 2 }}
                    icon={<DeleteOutlined />}
                    shape="default"
                    type="primary"
                    onClick={() => handleDeleteAvailableUnit(record.id)}
                  >
                    
                  </Button>
                </Tooltip>
            </>
            )}
        </>
      ),
    },
  ];
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleSearchDate = (selectedKeys, confirm, dataIndex) => {
    confirm();
  };
  const handleReset = (clearFilters, selectedKeys, confirm, dataIndex) => {
    clearFilters();
    setSearchText('');
    startDate[dataIndex] = '';
    endDate[dataIndex] = '';
  };
  const handleChange = (pagination, filters, sorter, extra) => {
    const dateFilters = { startDates: startDate, endDates: endDate}
    saveFilteredDataToLocalStorage('availableUnits', pagination, sorter, filters, dateFilters);
    setFilteredInfo(filters);
  };
  const exportPdf = (quotes, startDate, endDate) => {
    let mstrTitulo = '';
    let mstrPdf = '';
    mstrTitulo = `Unidades disponibles`;
    mstrPdf = `Unidades disponibles-${moment().format('L')}.pdf`;

    let registros = [];

    quotes.forEach((element) => {
      registros.push([
        element.serviceDescription,
        element.equipmentTypeDescription,
        element.locationCityDescription + " " + element.locationStateDescription,
        moment.unix(element.date).tz('GMT').format('DD/MM/YYYY'),
        element.loadTypeDescription,
        element.destinationCityDescription + " " + element.destinationStateDescription,
        element.status === 0 ? 'Disponible' : element.status === 1 ? 'Apartado' : 'Expirado',
        element.supplierId,
      ]);
    });

    let fecha = moment().format('LLL');
    let doc = new jsPDF('landscape');
    doc.setFontSize(12);

    let xFecha = 220;
    let yFecha = 10;

    let totalPagesExp = '{total_pages_count_string}';

    let pageContent = function (data) {
      //header
      doc.text(15, 10, mstrTitulo);
      doc.text(-10, -10, mstrTitulo);
      doc.text(fecha, xFecha, yFecha);
      // FOOTER
      let str = 'Página ' + data.pageCount;
      //Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' de ' + totalPagesExp;
      }
      doc.setFontSize(10);
      doc.text(
        str,
        data.settings.margin.left,
        doc.internal.pageSize.height - 10
      );
    };
    doc.autoTable({
        A3: { v: 'Servicio', t: 's' },
        B3: { v: 'Unidad', t: 's' },
        C3: { v: 'Ubicación', t: 's' },
        D3: { v: 'Fecha', t: 's' },
        E3: { v: 'Carga', t: 's' },
        F3: { v: 'Destino', t: 's' },
        G3: { v: 'Estatus', t: 's' },
        H3: { v: 'Proveedor', t: 's' },
      head: [
        [
          'Servicio',
          'Unidad',
          'Ubicación',
          'Fecha',
          'Carga',
          'Destino',
          'Estatus',
          'Proveedor',
        ],
      ],
      didDrawPage: pageContent,
      theme: 'grid',
      headStyles: {
        valign: 'middle',
        halign: 'center',
        fillColor: [230, 81, 0],
        textColor: [255, 255, 255],
        // cellWidth: { 3: 200 },
      },
      body: registros,
      columnStyles: {
        text: {
          cellWidth: 'wrap',
        },
      },
    });
    // call footer() after each doc.addPage()
    // and before doc.save() do not forget put
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }
    //spinner.style.display = 'none';
    doc.save(mstrPdf);
  };
  const generateExcel = (entries) => {
    // setExcelLoading(true);
    let filename = '';
    let mstrTitulo = '';
    filename = `Unidades-disponibles-${moment().format('L')}.xlsx`;
    mstrTitulo = `Unidades disponibles`;

    let fecha = moment().format('LLL');
    const ws_name = 'Hoja1';
    let wb = {
      SheetNames: [],
      Sheets: {},
    };
    let ws = {};
    let renInicial = 4;

    // var mstrTitulo = `Facturación y notas de crédito del ${dateRange.startDate} al: ${dateRange.endDate}`;

    ws = {
      A1: { v: mstrTitulo, t: 's' },
      I1: { v: fecha, t: 's' },

      A3: { v: 'Servicio', t: 's' },
      B3: { v: 'Unidad', t: 's' },
      C3: { v: 'Ubicación', t: 's' },
      D3: { v: 'Fecha', t: 's' },
      E3: { v: 'Carga', t: 's' },
      F3: { v: 'Destino', t: 's' },
      G3: { v: 'Estatus', t: 's' },
      H3: { v: 'Proveedor', t: 's' },
    };
    for (let i in entries) {

      const {
        serviceDescription,
        equipmentTypeDescription,
        locationCityDescription,
        locationStateDescription,
        date,
        loadTypeDescription,
        destinationCityDescription,
        destinationStateDescription,
        status,
        supplierId,
      } = entries[i];
      ws['A' + renInicial] = { v: serviceDescription, t: 's' };
      ws['B' + renInicial] = { v: equipmentTypeDescription, t: 's' };
      ws['C' + renInicial] = { v: locationCityDescription + " " + locationStateDescription, t: 's' };
      ws['D' + renInicial] = { v: moment.unix(date).tz('GMT').format('DD/MM/YYYY'),t: 's',};
      ws['E' + renInicial] = { v: loadTypeDescription,t: 's',};
      ws['F' + renInicial] = { v: destinationCityDescription + " " + destinationStateDescription, t: 's' };
      ws['G' + renInicial] = { v: status === 0 ? 'Disponible' : status === 1 ? 'Apartado' : 'Expirado', t: 's' };
      ws['H' + renInicial] = { v: supplierId, t: 's' };
     

      renInicial++;
    }
    // var wscols = [{ wch: 30 }, { wch: 40 }, { wch: 35 }, { wch: 35 }];
    // ws['!cols'] = wscols;
    ws['!ref'] = XLSX.utils.encode_range({
      s: { c: 0, r: 0 },
      e: { c: 15, r: renInicial },
    });
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    XLSX.writeFile(wb, filename, { cellStyles: true });
    // setExcelLoading(false);
  };
  return (
    <div>
         <Button
          className="btn-download"
          onClick={() => showModal('add')}
          icon={<PlusCircleOutlined />}
        >
          Agregar
        </Button>
          <Button
            className={classButtonDownload}
            icon={<ReloadOutlined />}
            onClick={() => setReloadTable(true)}
          >
            Refrescar
          </Button>
       
      <Table
        dataSource={quotes}
        columns={columns}
        bordered
        size="middle"
        scroll={{ x: 1200 }}
        // setSelectedRowKeys
        className="table-striped-rows"
        // rowSelection={rowSelection}
        loading={isLoadingTable || reloadTable}
        onChange={handleChange}
      />
      <Row>
        <Col span={24} style={{ textAlign: 'right' }}>
          <Button
            icon={<FilePdfFilled style={{ fontSize: 18 }} />}
            className="btn-download"
            onClick={() => exportPdf(quotes)}
            disabled={quotes.length === 0}
            style={{ width: 150 }}
          >
            Descargar Pdf
          </Button>
          <Button
            icon={<FileExcelFilled style={{ fontSize: 18 }} />}
            className="btn-download"
            onClick={() => generateExcel(quotes)}
            disabled={quotes.length === 0}
            style={{ width: 160 }}
          >
            Descargar Excel
          </Button>
        </Col>
      </Row>
      <Modal
        title={titleModal}
        visible={modalIsVisible}
        setIsVisible={setModalIsVisible}
        width={1000}
      >
        {contextModal}
      </Modal>
    </div>
  );
};

export default AvailableUnitsTable;
